import { useEffect } from "react";

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `Cub-Care | ${title}`;
  }, [title]);
};

export default usePageTitle;
